import React, { useContext } from 'react';
import { DATA_DOWNLOAD_TYPES } from '@shared/constants/DataDownloadTypes';
import { LocalFilesService } from '@shared/services/localFilesService';
import { getReport } from '../../shared/services/downloadReportService';
import { PageLoadingContext } from '../../loader/contexts/PageLoadingContext';
import { REPORT_FORMAT_TYPES } from '@shared/constants/reportFormatTypes';
import { showErrorToast } from '@shared/services/toastService';

const FILE_NAME = 'ExecutiveSummary.zip';

/**
 * @typedef {object} DownloadReportButtonProps
 * @property {number} orgId
 */

/**
 * @param {DownloadReportButtonProps} props
 */
const DownloadReportButton = props => {
  const { orgId } = props;

  const { executeWithLoadingIndicator } = useContext(PageLoadingContext);

  const handleDownloadReport = async () =>
    await executeWithLoadingIndicator(async () => {
      try {
        const response = await getReport(
          { orgId: orgId },
          DATA_DOWNLOAD_TYPES.executiveSummary,
          REPORT_FORMAT_TYPES.PDF
        );

        LocalFilesService.saveBlobToFile(FILE_NAME, response.data);
      } catch (e) {
        showErrorToast('Error downloading report');
      }
    });

  return (
    <div>
      <button
        data-testid='download-button'
        className='primary-button'
        onClick={handleDownloadReport}>
        Download Report
      </button>
    </div>
  );
};

export default DownloadReportButton;
